var _a;
import { Ribbon_Health_Specialty_Search_Name } from 'generated/types';
import { enumValuesFactory } from 'utils/objectHelper';
var enumDescriptionMap = (_a = {},
    _a[Ribbon_Health_Specialty_Search_Name.Acupunct] = 'Acupuncturist',
    _a[Ribbon_Health_Specialty_Search_Name.Allergist] = 'Allergist',
    _a[Ribbon_Health_Specialty_Search_Name.Audiolog] = 'Audiologist (Hearing Aids)',
    _a[Ribbon_Health_Specialty_Search_Name.Cardiolog] = 'Cardiologist',
    _a[Ribbon_Health_Specialty_Search_Name.Chiropract] = 'Chiropractor',
    _a[Ribbon_Health_Specialty_Search_Name.Dent] = 'Dentists and Dental Specialists',
    _a[Ribbon_Health_Specialty_Search_Name.Dentist] = 'General Dentist',
    _a[Ribbon_Health_Specialty_Search_Name.Dermatol] = 'Dermatologist',
    _a[Ribbon_Health_Specialty_Search_Name.Endocrinolog] = 'Endocrinologist (Hormones, Thyroid, Osteoporosis, and/or Diabetes)',
    _a[Ribbon_Health_Specialty_Search_Name.Endodont] = 'Endodontist',
    _a[Ribbon_Health_Specialty_Search_Name.Eye] = 'Eye Doctors',
    _a[Ribbon_Health_Specialty_Search_Name.Family] = 'Family Medicine Doctor',
    _a[Ribbon_Health_Specialty_Search_Name.Gastro] = 'Gastroenterologist (Colonoscopy)',
    _a[Ribbon_Health_Specialty_Search_Name.Gynecolog] = 'Obstetrician-Gynecologists (OBGYNs)',
    _a[Ribbon_Health_Specialty_Search_Name.Hematolog] = 'Hematologist (Blood Specialist)',
    _a[Ribbon_Health_Specialty_Search_Name.Infect] = 'Infectious Disease Specialist',
    _a[Ribbon_Health_Specialty_Search_Name.Mental] = 'Mental Health Providers',
    _a[Ribbon_Health_Specialty_Search_Name.Nephrolog] = 'Nephrologist (Kidney Specialist)',
    _a[Ribbon_Health_Specialty_Search_Name.Neurolog] = 'Neurologist (Headache and Nervous System)',
    _a[Ribbon_Health_Specialty_Search_Name.Neurosurgeon] = 'Neurosurgeon',
    _a[Ribbon_Health_Specialty_Search_Name.Nutrition] = 'Dietician / Nutritionist',
    _a[Ribbon_Health_Specialty_Search_Name.Obgyn] = 'General OBGYN',
    _a[Ribbon_Health_Specialty_Search_Name.Obsetrician] = 'Obsetrician',
    _a[Ribbon_Health_Specialty_Search_Name.Occupat] = 'Occupational Therapy',
    _a[Ribbon_Health_Specialty_Search_Name.Oncolog] = 'Oncologist (Cancer Specialist)',
    _a[Ribbon_Health_Specialty_Search_Name.Ophthalmolog] = 'Ophthalmologist',
    _a[Ribbon_Health_Specialty_Search_Name.Optometr] = 'Optometrist',
    _a[Ribbon_Health_Specialty_Search_Name.Oral] = 'Oral Surgeon',
    _a[Ribbon_Health_Specialty_Search_Name.Orthodont] = 'Orthodontist',
    _a[Ribbon_Health_Specialty_Search_Name.Orthoped] = 'Orthopedist/Orthopedic Surgeon',
    _a[Ribbon_Health_Specialty_Search_Name.Otolaryng] = 'Ear, Nose, & Throat Doctor (ENT/Otolaryngologist)',
    _a[Ribbon_Health_Specialty_Search_Name.Pain] = 'Pain Medicine Specialist',
    _a[Ribbon_Health_Specialty_Search_Name.Pediatr] = 'Pediatricians',
    _a[Ribbon_Health_Specialty_Search_Name.Periodont] = 'Periodontist',
    _a[Ribbon_Health_Specialty_Search_Name.Physiatr] = 'Physiatrist (Physical Medicine)',
    _a[Ribbon_Health_Specialty_Search_Name.Physic] = 'Physical Therapy',
    _a[Ribbon_Health_Specialty_Search_Name.Podiatr] = 'Podiatrist (Foot/Ankle Specialist)',
    _a[Ribbon_Health_Specialty_Search_Name.PrimaryCare] = 'Primary Care Physicians (PCPs)',
    _a[Ribbon_Health_Specialty_Search_Name.Proctolog] = 'Proctologist / Colorectal Surgeon',
    _a[Ribbon_Health_Specialty_Search_Name.Prosthodont] = 'Prosthodontist',
    _a[Ribbon_Health_Specialty_Search_Name.Psychiatr] = 'Psychiatrist / Medication Management',
    _a[Ribbon_Health_Specialty_Search_Name.Psycholog] = 'Psychologist / Therapist',
    _a[Ribbon_Health_Specialty_Search_Name.Pulmonolog] = 'Pulmonologist (Lung Specialist)',
    _a[Ribbon_Health_Specialty_Search_Name.Reconstruct] = 'Plastic / Reconstructive Surgeon',
    _a[Ribbon_Health_Specialty_Search_Name.Reproduc] = 'Reproductive Endocrinologist',
    _a[Ribbon_Health_Specialty_Search_Name.Reproduct] = 'Reproductive Endocrinologist (Fertility Specialist)',
    _a[Ribbon_Health_Specialty_Search_Name.Rheumatolog] = 'Rheumatologist (Arthritis and/or Autoimmune Conditions)',
    _a[Ribbon_Health_Specialty_Search_Name.Sleep] = 'Sleep Specialist',
    _a[Ribbon_Health_Specialty_Search_Name.Speech] = 'Speech Therapy',
    _a[Ribbon_Health_Specialty_Search_Name.Surgeo] = 'General Surgeon',
    _a[Ribbon_Health_Specialty_Search_Name.Surgeon] = 'Surgeons',
    _a[Ribbon_Health_Specialty_Search_Name.Urolog] = 'Urologist',
    _a[Ribbon_Health_Specialty_Search_Name.Vascular] = 'Vascular Surgeon',
    _a[Ribbon_Health_Specialty_Search_Name.Women] = 'Gynecologist',
    _a);
export var RibbonHealthSpecialtySearchNameEnum = {
    name: 'Ribbon_Health_Specialty_Search_Name',
    enumValues: enumValuesFactory(enumDescriptionMap)
};
